<template>
  <tr class="my-list-row selectable">
    <td>
      <span class="text-bigger mr-2">{{ object.ref }}</span>
    </td>
  </tr>
</template>

<script>

export default {
  name: "ContractResultRow",
  props: {
    object: {
      type: Object,
      required: true,
    },
  },
};
</script>
